import React, { useState, useEffect } from 'react';
import Text from '../../atoms/Text/Text';
import Image from '../../atoms/Image/Img';
import StatutoryBodyTableStyle from './StatutoryBodyTableStyle';
import nike from '../../../assets/images/nike.svg';
import elipses from '../../../assets/images/elipses.svg';
import user from '../../../assets/images/user-male.svg';
import Pagination from '../Pagination/Pagination';
import UpdateStatutoryBodyModal from '../UpdateStatutoryBodyModal/UpdateStatutoryBodyModal';
import dayjs from 'dayjs';
import {useDispatch, useSelector} from 'react-redux';
import { TypedDispatch, RootStore } from '../../../config/ConfigStore';
import {exportData} from '../../../redux/actions/ExportAction';
import { useNavigate } from "react-router-dom";
import { alertActions } from '../../../redux/actions/AlertActions';
import {appInstance as axios} from '../../../axios';
import Cookies from 'js-cookie';


type UserTableProps = {
  data: any,
  pagination: number,
  setPagination: Function,
  changePage: Function,
  page: number,
  reloadPage: Function
}

const StatutoryBodyTable = ({data, pagination, setPagination, changePage, page, reloadPage}: UserTableProps) => {
  const [toggleUpdateStatutoryBodyModal, setToggleUpdateStatutoryBodyModal] = useState(false);
  let timeOutId:any = null;
  const [selectedMenu, setSelectedMenu] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const dispatch: TypedDispatch = useDispatch();
  const state:any = useSelector( (state:RootStore) => state);
  const [statutoryBodyData, setStatutoryBodyData] = useState({});

  const onClickHandler = (value: boolean, id: string) => {
    if(selectedMenu !== false){
      setSelectedMenu(false);
      return;
    }
    setSelectedMenu(value);
    setSelectedId(id)
  }

  const onBlurHandler = () => {

      timeOutId = setTimeout(() => {
        setSelectedMenu(false);
      });
  }

  const onFocusHandler = () =>{
      clearTimeout(timeOutId);
  }

  const showUpdateStatutoryBodyModal = () => {
    let statutoryBodyData = data.data.content.filter((data: Record<any, any>) => data.id === selectedId);
    let value = {
      ...statutoryBodyData[0]
    }
    console.log(value)
    setStatutoryBodyData(value);
    setToggleUpdateStatutoryBodyModal(true);
  }

  const hideUpdateStatutoryBodyModal = () => {
    setToggleUpdateStatutoryBodyModal(false);
  }

  const renderUpdateStatutoryBodyModal = () => {
    if(toggleUpdateStatutoryBodyModal){
      return(
        <UpdateStatutoryBodyModal handleClose={hideUpdateStatutoryBodyModal} reloadPage={reloadPage} data={statutoryBodyData}/>
      )
    }
  }

  const handleAllCheck = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      await dispatch(exportData(state.dashboardReducer.results.data.content))
      console.log(state.exportReducer);
    }
    else{
      await dispatch(exportData([]));
      console.log(state.exportReducer);
    }
  };

  const handleCheckItem = (item: Record<any, any>) => {
    if(state.exportReducer.results.data.includes(item)){
      const newArr = state.exportReducer.results.data.filter( (record: Record<any,any>) => record.id !== item.id)
      console.log(newArr);
      return dispatch(exportData(newArr));
    }
    const update = [...state.exportReducer.results.data, item]
    console.log(update);
    return dispatch(exportData(update));
  };

  return (
    <>
      {renderUpdateStatutoryBodyModal()}
      <StatutoryBodyTableStyle>
        <div className={`container-full`}>
          <table>
            <thead>
              <tr className={`table-header`}>
                <th>
                  <input type="checkbox" onChange={handleAllCheck}/>
                  <Image image={nike} />
                </th>
                <th>
                  <Text value="Institution Name" className={`table-title`} />
                </th>
                <th>
                  <Text value="Category" className={`table-title`} />
                </th>
                <th>
                  <Text value="Settlement Account" className={`table-title`} />
                </th>
                <th>
                  <Text value="Settlement Bank" className={`table-title`} />
                </th>
                <th>
                  <Text value="Contact" className={`table-title`} />
                </th>
                <th>
                  <Text value="Date Added" className={`table-title`} />
                </th>
                <th>
                  <Text value="More" className={`table-title`} />
                </th>
              </tr>
            </thead>
            <tbody className={`table-body`}>
            {
                (data.data.content !== undefined && data.data.content.length > 0) ?
                data.data.content.map((statutoryBody: Record<any, any>, key: string) => {
                  return (
                    <tr className={`table-row`} key={key}>
                      <td>
                        <input
                          type="checkbox"
                          checked={state.exportReducer.results.data.includes(
                            statutoryBody
                          )}
                          onChange={() => handleCheckItem(statutoryBody)}
                        />
                        <Image image={nike} />
                      </td >
                      <td> 
                        <Text value={statutoryBody.name} className='label' />
                      </td>
                      <td> 
                        {
                          (statutoryBody.category === 1) ? <Text value={`PAYE`} className='label' /> : null
                        }
                        {
                          (statutoryBody.category === 2) ? <Text value={`NHIS`} className='label' /> : null
                        }
                        {
                          (statutoryBody.category === 3) ? <Text value={`NHF`} className='label' /> : null
                        }
                        {
                          (statutoryBody.category === 4) ? <Text value={`PFA`} className='label' /> : null
                        }
                      </td>
                      <td> 
                        <Text value={statutoryBody.settlementDetails && statutoryBody.settlementDetails.settlementAccount} className='label' />
                      </td>
                      <td> 
                        <Text value={statutoryBody.settlementDetails && statutoryBody.settlementDetails.bankName} className='label' />
                      </td>
                      <td> 
                        <Text value={statutoryBody.contactEmail} className='label' />
                        <Text value={statutoryBody.contactPhone} className='sublabel' />
                      </td>
                      <td> 
                        <Text value={dayjs(statutoryBody.createdDate).format('MM/DD/YYYY')} className='label' />
                        <Text value={dayjs(statutoryBody.createdDate).format('h:mm A')} className='date' />
                      </td>
                      <td> 
                        <div className={`container-full`} onBlur={() => onBlurHandler()} onFocus={() => onFocusHandler()}>
                            <button className={`button --elipses`} onClick={() => onClickHandler(true, statutoryBody.id)} aria-haspopup="true" aria-expanded={selectedMenu}>
                              <Image image={elipses} />
                            </button>
                            {
                                selectedMenu !== false && selectedId === statutoryBody.id && (
                                  <div className={`container-full more-info`}>
                                    <div className={`container-full more-info__item ${
                                     state.authReducer.results.roles.includes('Administrator') ? '' : 'disabled'
                                    }`}>
                                      <button onClick={() => showUpdateStatutoryBodyModal()}>
                                        <Text value='Edit' />
                                      </button>
                                    </div> 
                                  </div>
                                )
                            }
                          </div>
                      </td>
                    </tr>
                  )
                }) : null
              }          
            </tbody>
          </table>
        </div>
        <div className={`container-full pagination`}>
          <Pagination pagination={pagination} changePage={changePage} setPagination={setPagination} page={page}/> 
        </div>
      </StatutoryBodyTableStyle>
    </>
  );
};

export default StatutoryBodyTable;
